import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "login-container" }
const _hoisted_2 = { class: "input-group" }
const _hoisted_3 = { class: "input-group" }
const _hoisted_4 = { class: "input-group" }
const _hoisted_5 = { class: "input-group" }
const _hoisted_6 = { class: "input-group" }
const _hoisted_7 = { class: "agreement" }

import { ref, onMounted, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import { showToast } from 'vant'
import CustomTitleBar from "@/components/CustomTitleBar/index.vue"
import { getCaptcha, sendSmsCode, registerApi } from '@/api/system'


export default /*@__PURE__*/_defineComponent({
  __name: 'register',
  setup(__props) {

const router = useRouter()

// 表单数据
const phoneAreaPrefix = ref('86')
const phoneNumber = ref('')
const password = ref('')
const captcha = ref('')
const captchaUrl = ref('')
const verificationCode = ref('')
const agreed = ref(false)
const cooldownTime = ref(0)
const showAreaCodePicker = ref(false)
let timer: ReturnType<typeof setInterval> | null = null
const clientType = ref('web') // 客户端类型
const onlyCode = ref('') // 唯一码
const inviteCode = ref('') // 邀请码

// 区号数据
const areaCodeColumns = [
  { text: '中国 +86', value: '86' },
  { text: '中国香港 +852', value: '852' },
  { text: '中国澳门 +853', value: '853' },
  { text: '中国台湾 +886', value: '886' },
  { text: '日本 +81', value: '81' },
  { text: '韩国 +82', value: '82' },
  { text: '美国 +1', value: '1' },
]

// 表单验证
const validateForm = () => {
  if (!phoneNumber.value) {
    showToast('请输入手机号')
    return false
  }
  if (!/^1[3-9]\d{9}$/.test(phoneNumber.value)) {
    showToast('请输入正确的手机号')
    return false
  }
  if (!password.value) {
    showToast('请输入密码')
    return false
  }
  if (password.value.length < 6) {
    showToast('密码长度不能少于6位')
    return false
  }
  if (!captcha.value) {
    showToast('请输入图形验证码')
    return false
  }
  if (!verificationCode.value) {
    showToast('请输入验证码')
    return false
  }
  if (!inviteCode.value) {
    showToast('请输入邀请码')
    return false
  }
  if (!agreed.value) {
    showToast('请先同意服务条款和隐私协议')
    return false
  }
  return true
}

// 提交注册
const submitForm = async () => {
  if (!validateForm()) return

  try {
    const res = await registerApi({
      phoneAreaPrefix: phoneAreaPrefix.value,
      phoneNumber: phoneNumber.value,
      password: password.value,
      captcha: verificationCode.value, // 图形验证码
      clientType: clientType.value,
      inviteCode: inviteCode.value || '' // 邀请码，可选
    })

    if (res.code === 200) {
      showToast('注册成功')
      router.push('/login')
    } else {
      showToast(res.msg)
    }
  } catch (error) {
    console.error('注册失败：', error)
    showToast('注册失败，请重试')
  }
}

// 刷新图形验证码
const refreshCaptcha = async () => {
  try {
    const res = await getCaptcha()
    captchaUrl.value = URL.createObjectURL(res)
  } catch (error) {
    console.error('验证码获取失败：', error)
  }
}

// 发送验证码
const sendVerificationCode = async () => {
  if (!phoneNumber.value || cooldownTime.value > 0) return

  try {
    const res = await sendSmsCode({
      phoneAreaPrefix: phoneAreaPrefix.value,
      phoneNumber: phoneNumber.value,
      captcha: captcha.value,
      type: 1, // 注册验证码类型
    })

    if (res.code === 200) {
      showToast('验证码已发送')
      cooldownTime.value = 60
      timer = setInterval(() => {
        cooldownTime.value--
        if (cooldownTime.value <= 0 && timer) {
          clearInterval(timer)
          timer = null
        }
      }, 1000)
    } else {
      showToast(res.msg)
      refreshCaptcha()
    }
  } catch (error) {
    console.error('发送验证码失败：', error)
    showToast('发送失败，请重试')
  }
}

// 区号选择
const onAreaCodeConfirm = (item: any) => {
  phoneAreaPrefix.value = item.selectedValues[0]
  showAreaCodePicker.value = false
}

onMounted(() => {
  refreshCaptcha()
})

onUnmounted(() => {
  if (timer) {
    clearInterval(timer)
  }
  if (captchaUrl.value) {
    URL.revokeObjectURL(captchaUrl.value)
  }
})

return (_ctx: any,_cache: any) => {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_checkbox = _resolveComponent("van-checkbox")!
  const _component_van_picker = _resolveComponent("van-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CustomTitleBar),
    _createElementVNode("div", _hoisted_1, [
      _cache[11] || (_cache[11] = _createElementVNode("h2", { class: "title" }, "注册账户", -1)),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_van_field, {
          modelValue: phoneNumber.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((phoneNumber).value = $event)),
          placeholder: "输入手机号",
          border: false
        }, {
          label: _withCtx(() => [
            _createElementVNode("div", {
              class: "country-code",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (showAreaCodePicker.value = true))
            }, [
              _createVNode(_component_SvgIcon, {
                name: "phone",
                size: "16"
              }),
              _createElementVNode("span", null, "+" + _toDisplayString(phoneAreaPrefix.value), 1),
              _createVNode(_component_van_icon, {
                name: "arrow-down",
                size: "14",
                color: "#666666"
              })
            ])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_van_field, {
          modelValue: password.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((password).value = $event)),
          type: "password",
          placeholder: "输入密码",
          border: false
        }, {
          label: _withCtx(() => [
            _createVNode(_component_SvgIcon, { name: "pwd" })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_van_field, {
          modelValue: captcha.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((captcha).value = $event)),
          placeholder: "输入图形验证码",
          border: false
        }, {
          label: _withCtx(() => [
            _createVNode(_component_SvgIcon, {
              name: "code",
              size: "16"
            })
          ]),
          "right-icon": _withCtx(() => [
            _createVNode(_component_el_image, {
              class: "captcha-img",
              src: captchaUrl.value,
              onClick: refreshCaptcha
            }, null, 8, ["src"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_van_field, {
          modelValue: verificationCode.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((verificationCode).value = $event)),
          placeholder: "输入验证码",
          border: false
        }, {
          label: _withCtx(() => [
            _createVNode(_component_SvgIcon, {
              name: "code2",
              size: "16"
            })
          ]),
          "right-icon": _withCtx(() => [
            _createVNode(_component_van_button, {
              size: "small",
              plain: "",
              type: "primary",
              onClick: sendVerificationCode,
              disabled: cooldownTime.value > 0
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(cooldownTime.value > 0 ? `${cooldownTime.value}s` : '获取验证码'), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_van_field, {
          modelValue: inviteCode.value,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((inviteCode).value = $event)),
          placeholder: "输入邀请码",
          border: false
        }, {
          label: _withCtx(() => [
            _createVNode(_component_SvgIcon, {
              name: "invite",
              size: "16"
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createVNode(_component_van_button, {
        type: "primary",
        block: "",
        round: "",
        onClick: submitForm
      }, {
        default: _withCtx(() => _cache[9] || (_cache[9] = [
          _createTextVNode("注册")
        ])),
        _: 1
      }),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_van_checkbox, {
          modelValue: agreed.value,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((agreed).value = $event)),
          shape: "round",
          "icon-size": "12"
        }, {
          default: _withCtx(() => _cache[10] || (_cache[10] = [
            _createTextVNode(" 注册即表示同意"),
            _createElementVNode("a", {
              href: "https://www.jingchat.cn/userProtocol.html",
              target: "_blank"
            }, "《服务条款》", -1),
            _createTextVNode("和"),
            _createElementVNode("a", {
              href: "https://www.hnmengyuqianfang.cn/features.html",
              target: "_blank"
            }, "《隐私协议》", -1)
          ])),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createVNode(_component_van_popup, {
        show: showAreaCodePicker.value,
        "onUpdate:show": _cache[8] || (_cache[8] = ($event: any) => ((showAreaCodePicker).value = $event)),
        position: "bottom"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_picker, {
            columns: areaCodeColumns,
            onConfirm: onAreaCodeConfirm,
            onCancel: _cache[7] || (_cache[7] = ($event: any) => (showAreaCodePicker.value = false)),
            title: '选择区号',
            "show-toolbar": ""
          })
        ]),
        _: 1
      }, 8, ["show"])
    ])
  ], 64))
}
}

})